module.exports = __webpack_public_path__ + "static/media/PDF_129.8741af85.pdf";